import {
	isEnabled,
	isReadonly,
	isVisible
} from "@jsonforms/core";
import type Ajv from "ajv";

import type {
	ElementState,
	FormUiSchema
} from "./types";

/** Evaluate native rules against the current form data. */
export function elementState(
	ui: FormUiSchema,
	data: unknown,
	basePath: string,
	ajv: Ajv,
	parentVisible = true,
	parentEnabled = true,
	readonly = false
): ElementState {
	const visible = parentVisible && isVisible(ui, data, basePath, ajv, {});
	const enabled = parentEnabled
		&& !readonly
		&& !ui.options?.readonly
		&& !ui.options?.readOnly
		&& isEnabled(ui, data, basePath, ajv, {})
		&& !isReadonly(ui, data, basePath, ajv, {});

	return {
		visible,
		enabled
	};
}
